import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../components/context/SnackbarContext";
import useAxios from "../../hooks/useAxios";
import { useLoader } from "../../components/context/LoaderContext";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { capitalize, displayCurrencySymbol, displayDate } from "../../utils/Utils";
import EmptyState from "../../components/common/EmptyState";


function SalesQuoteList(props) {
    const navigate = useNavigate();
    const axiosInstance = useAxios();
    const { showSnackbar } = useSnackbar();
    const { showLoader, hideLoader } = useLoader();
    const { preferredDateFormat, preTimeZoneKey, currencySymbol, currencyCode, currencyStringValue } = useSelector((state) => state?.user);

    const startDate = props?.startDate
    const endDate = props?.endDate
    const userID = props?.userID

    //add for handle apply button
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(
        parseInt(process.env.REACT_APP_DEFAULT_PAGINATION)
    );
    const [totalCount, setTotalCount] = useState(0);
    const sortOrder = process.env.REACT_APP_DEFAULT_SORT
    const sortBy = 'created_at'
    const [salesQuotaDataList, setSalesQuotaDataList] = useState([]);

    useEffect(() => {
        async function fetchData() {
            showLoader();
            await getData(
                currentPage,
                perPage,
                sortBy,
                sortOrder,
                userID,
            );
        }
        fetchData();
    }, [
        currentPage,
        perPage,
        startDate,
        endDate,
        userID
    ]);

    const getData = async (
        currentPage,
        perPage,
        sortBy,
        sortOrder,
    ) => {
        const params = {
            user_id: props?.userID || '',
            sort_field: sortBy,
            sort_order: sortOrder,
            start_date: props.startDate ? moment(props.startDate).format("YYYY-MM-DD") : '',
            end_date: props.endDate ? moment(props.endDate).format("YYYY-MM-DD") : '',
            per_page: perPage,
        };
        showLoader()
        await axiosInstance.get(`api/sales-quota?page=${currentPage + 1}`, { params }).then((response) => {
            if (response.status === 200) {
                setSalesQuotaDataList(response.data.data.records.data);
                setTotalCount(response?.data?.data?.records?.total);
                hideLoader();
            }
        })
            .then((json) => { })
            .catch((error) => {
                if (error.response) {
                    hideLoader();
                    if (error.response.status === 400) {
                        showSnackbar(error.response.data.message, "warning");
                        navigate("/dashboard");
                    }
                }
            });
    };

    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0);
    };

    return (
        <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>User</TableCell>
                            <TableCell>Quota Subject</TableCell>
                            <TableCell>Targeted Amount</TableCell>
                            <TableCell>Achieved Amount</TableCell>
                            <TableCell>Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.isArray(salesQuotaDataList) && salesQuotaDataList.length > 0 ? (
                            salesQuotaDataList.map((salesQuota, index) => (
                                <TableRow key={index}>
                                    <TableCell>{capitalize(salesQuota?.added_by?.name || '')}</TableCell>
                                    <TableCell>
                                        <a href="-" onClick={e => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            navigate(`/quote-detail/${salesQuota?.quote_id}`)
                                        }} className="primary-link">
                                            {salesQuota?.subject || ''}
                                        </a>
                                    </TableCell>
                                    <TableCell>
                                        {salesQuota?.target_amount
                                            ? displayCurrencySymbol(salesQuota.target_amount, currencyCode, currencySymbol, currencyStringValue)
                                            : 'N/A'}
                                    </TableCell>
                                    <TableCell>
                                        {salesQuota?.achieved_amount
                                            ? displayCurrencySymbol(salesQuota.achieved_amount, currencyCode, currencySymbol, currencyStringValue)
                                            : 'N/A'}
                                    </TableCell>
                                    <TableCell>
                                        {salesQuota?.date
                                            ? displayDate(moment.utc(salesQuota.date).tz(preTimeZoneKey).format(preferredDateFormat), 'half')
                                            : 'N/A'}
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                {/* <TableCell colSpan={5} align="center">
                                    No Record Found
                                </TableCell> */}
                            </TableRow>
                        )
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            {(salesQuotaDataList?.length === 0) &&
                <EmptyState type={'salesQuote'} size={'small'} hideActionBtn />
            }

            {
                salesQuotaDataList && salesQuotaDataList.length > 0 &&
                <div className="pt-16">
                    <TablePagination
                        component="div"
                        count={totalCount}
                        page={currentPage}
                        rowsPerPage={perPage}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                    />
                </div>
            }
        </>
    );
}

export default SalesQuoteList;